import Swiper, { Navigation ,Thumbs, Lazy } from 'swiper';
import zoom from 'jquery-zoom';

var zoomInstance;
var zoomOptions = {
    offset: {vertical: 0, horizontal: 0},
	zoomContainer: document.querySelector('.col-photos')
  };

Swiper.use([Navigation]);
Swiper.use([Thumbs]);
Swiper.use([Lazy]);

var galleryThumbs = new Swiper('.gallery-thumbs', {
	spaceBetween: 10,
	lazy: true,
	slidesPerView: 4,
	freeMode: true,
	watchSlidesVisibility: true,
	watchSlidesProgress: true,
	});
	
var galleryTop = new Swiper('.gallery-top', {
	spaceBetween: 0,
	lazy: true,
	zoom: true,
	watchOverflow : true,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	thumbs: {
		swiper: galleryThumbs
	}
}).on('imagesReady', function(instance){
	console.log("asd");
	// $('.swiper-slide-active .cover-slider').zoom();
}).on('slideChange', function(instance){
	console.log(instance);
	// $('.swiper-slide-active .cover-slider').trigger('zoom.destroy');
	// $('.swiper-slide-active .cover-slider').wrap('<span style="display:inline-block"></span>')
	// .css('display', 'block')
	// .parent()
	// .zoom({
	// 	magnify : 2
	// });
});

// $('.swiper-slide-active .cover-slider').wrap('<span style="display:inline-block"></span>')
// 	.css('display', 'block')
// 	.parent()
// 	.zoom({
// 		magnify : 3
// 	});


$('.sales-carousel').slick({
	lazyLoad: 'ondemand',
	slidesToShow: 6,
	slidesToScroll: 6,
	dots: true,
	infinite: false,
	arrows: true,
	responsive: [
		{
			breakpoint: 1800,
			settings: {
				slidesToShow: 5,
				slidesToScroll: 5
			}
		},
		  {
			breakpoint: 1682,
			settings: {
				slidesToShow: 4,
				slidesToScroll: 4
			}
		},{
			breakpoint: 1350,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 3
			}
		},{
		  breakpoint: 600,
		  settings: {
			slidesToShow: 2,
			slidesToScroll: 2
		  }
		},
		{
		  breakpoint: 480,
		  settings: {
			slidesToShow: 2,
			slidesToScroll: 2,
			arrows: false
		  }
		}
	  ]
  });
